import React from 'react';
import { Header, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import './SmartAssistant.css';

const SmartAssistant = () => {
  const { t } = useTranslation();

  return (
    <section className="clientSmartAssistant" aria-labelledby="smart-assistant-title">
      <div className="clientSmartAssistantIcon" aria-hidden="true">
        <Icon name="magic" />
      </div>
      <Header id="smart-assistant-title" as="h1">
        {t('smartAssistant')}
      </Header>
      <p>{t('smartAssistantPending')}</p>
    </section>
  );
};

export default SmartAssistant;
